import React, { useState } from "react";
import styles_field from "../Field/Field.module.css";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export function DatesFilter({
                                startValue = "",
                                endValue = "",
                                onChange = null,
                            }) {
    const [startDate, setStartDate] = useState(startValue);
    const [endDate, setEndDate] = useState(endValue);

    const handleStartDateChange = (e) => {
        setStartDate(e.target.value);
    };

    const handleEndDateChange = (e) => {
        setEndDate(e.target.value);
    };

    const handleApplyFilter = () => {
        if (onChange) {
            onChange(startDate, endDate);
        }
    };

    return (
        <div>
            <label>Dates</label>
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    padding: "8px",
                    outline: "1px solid var(--clr-accent)",
                }}
            >
                <div>
                    <span>De </span>
                    <input
                        type="date"
                        value={startDate}
                        onChange={handleStartDateChange}
                        className={styles_field.inputy}
                    />

                    <span> à </span>
                    <input
                        type="date"
                        value={endDate}
                        onChange={handleEndDateChange}
                        className={styles_field.inputy}
                    />
                </div>

                <button
                    onClick={handleApplyFilter}
                    className={"btn"}
                    title={"Appliquer"}
                >
                    <FontAwesomeIcon icon={faFilter} />
                </button>
            </div>
        </div>
    );
}
